import {
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { NotifyService } from '../services/notification/notify.service';
import { Auth } from '../store/auth/auth.actions';
import { UserActions } from '../store/users/user.actions';

// Variable para controlar si ya estamos en proceso de logout
let isLoggingOut = false;

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const store = inject(Store);
  const router = inject(Router);
  const notify = inject(NotifyService);

  const token = store.selectSnapshot<string>((state) => state.auth.token);

  // Solo ignoramos login y registro, pero permitimos logout
  if (
    request.url.includes('/auth/login') ||
    request.url.includes('/auth/register') ||
    request.url.includes('/assets/')
  ) {
    return next(request);
  }

  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isLoggingOut) {
        const url = request.url;
        if (!url.includes('/auth/change-password') && !url.includes('/auth/validate-current-password')) {
          if (error.error?.error === 'ACCOUNT_DEACTIVATED') {
            notify.show({ tipo: 'warn', titulo: error.error.message });
          }
          isLoggingOut = true;
          // Logout LOCAL: limpiamos el estado y redirigimos SIN llamar a
          // /auth/logout. El backend ya rechazó este token con el 401, así que
          // avisarle es innecesario — y dañino: /auth/logout invalida el token,
          // que está COMPARTIDO en localStorage entre pestañas, y desloguearía
          // a TODAS en cascada. El logout explícito (botón) sí pega al backend.
          store.dispatch(new Auth.LogoutSuccess());
          router.navigate(['/auth/login']).finally(() => {
            isLoggingOut = false;
          });
        }
      }

      if (error.status === 403 && !request.url.includes('/users/me')) {
        store.dispatch(new UserActions.GetMe()).subscribe({
          // Igual que arriba: reset local, sin pegarle a /auth/logout.
          error: () => store.dispatch(new Auth.LogoutSuccess()),
        });
      }

      return throwError(() => error);
    })
  );
};
